import { lazy } from 'react';

import type { AppRouteConfig } from '@/App/AppRoutes/types';

const ResetPasswordTokenInvalidPage = lazy(() =>
  import('@/components/pages/ResetPasswordTokenInvalidPage').then(({ ResetPasswordTokenInvalidPage }) => ({
    default: ResetPasswordTokenInvalidPage,
  })),
);

export const ResetPasswordTokenInvalidRoute: AppRouteConfig = {
  key: 'reset-password-token-invalid-page',
  path: '/reset_password_token_invalid/:locale?',
  component: ResetPasswordTokenInvalidPage,
};
